namespace TabAurous.Retail {
    export namespace POSSalesSelectItemsService {
        export const baseUrl = 'POSSales/POSSalesSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/POSSalesSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSSalesSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
